import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b389f54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-card p-shadow-2 p-text-bold p-p-3 p-text-center p-text-uppercase" }, " Gestion des clients ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.2em","line-height":"1.5em"} }, " Dans cette partie, vous allez pouvoir gérer tous vos clients. Entre autre, voir la liste des clients avec la possibilité de créer/modifier/supprimer un client. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: `background-image: url('/customer.PNG')`,
  class: "image p-my-3"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Pour créer un client, on demande les informations suivantes :", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "p-ml-6" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Nom *"),
  /*#__PURE__*/_createElementVNode("li", null, "Adresse(optionnelle)")
], -1))
const _hoisted_6 = { class: "p-d-flex p-justify-center p-pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        style: {"width":"50%"},
        label: "Passer à la section suivante",
        class: "p-button-warning p-shadow-4 p-py-3 p-button-rounded",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/documentation/expense')))
      })
    ])
  ], 64))
}